export default {
  extraFontSize: '12px',
  width: '440px'
}
